import type { ReactNode } from 'react';
import { msg } from '@gonfalon/messages/msg';
import { Dialog } from '@launchpad-ui/components';

export interface CommandPaletteDialogProps {
  children: ReactNode;
}

/**
 * Dialog component for the command palette.
 * Wraps children in a modal overlay.
 */
export function CommandPaletteDialog({ children }: CommandPaletteDialogProps) {
  return <Dialog aria-label={msg('commandPalette.dialog.label')}>{children}</Dialog>;
}
